"use client";

import { Mail } from "@/components/icons";
import {
 FacebookIcon,
 LinkedInIcon,
 TwitterIcon,
 WhatsAppIcon,
} from "./share-brand-icons";

export interface ShareTarget {
 name: string;
 icon: React.ReactNode;
 open: () => void;
}

export function getShareTargets(title: string, shareUrl: string): ShareTarget[] {
 const encodedUrl = encodeURIComponent(shareUrl);
 const encodedTitle = encodeURIComponent(title);
 const subject = `Check out: ${title}`;
 const body = `I thought you might be interested in this listing:\n\n${title}\n${shareUrl}`;
 return [
  {
   name: "Email",
   icon: <Mail className="size-5" />,
   open: () => window.open(`mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`),
  },
  {
   name: "WhatsApp",
   icon: <WhatsAppIcon />,
   open: () => window.open(`https://wa.me/?text=${encodedTitle}%20${encodedUrl}`, "_blank"),
  },
  {
   name: "Facebook",
   icon: <FacebookIcon />,
   open: () => window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`, "_blank"),
  },
  {
   name: "Twitter",
   icon: <TwitterIcon />,
   open: () => window.open(`https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedTitle}`, "_blank"),
  },
  {
   name: "LinkedIn",
   icon: <LinkedInIcon />,
   open: () => window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`, "_blank"),
  },
 ];
}
